//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { EVENTS } from '@/scripts/constants/css-classes'

export default {
  name: 'rb-registration-callout',

  props: {
    theme: {
      type: String,
      default: 'light', // options: ['dark', 'light']
    },
    href: {
      type: String,
      default: '#',
    },
  },

  data() {
    return {
      baseClass: 'rb-registration-callout',
      lastScrollPosition: 0,
      canShow: false,
      closed: false,
    }
  },

  computed: {
    modifierClasses() {
      return {
        [`${this.baseClass}`]: true,
        [`${this.baseClass}--${this.theme}`]: this.theme,
        [`${this.baseClass}--visible`]: this.visible,
        [`${this.baseClass}--hidden`]: !this.visible,
      }
    },

    iconClasses() {
      return this.theme === 'dark'
        ? 'common__icon--close-side-panel-light'
        : 'common__icon--close-side-panel'
    },

    visible() {
      return !this.closed && this.canShow
    },
  },
  mounted() {
    window.addEventListener(EVENTS.SCROLL, this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener(EVENTS.SCROLL, this.handleScroll)
  },
  methods: {
    handleScroll() {
      const currentScrollPosition = window.pageYOffset
      if (currentScrollPosition > 0) {
        this.canShow = true
      }

      this.lastScrollPosition = currentScrollPosition
    },

    close() {
      this.closed = true
      window.removeEventListener(EVENTS.SCROLL, this.handleScroll)
    },
  },
}
